import React, { Component } from "react";
import classnames from "classnames";
import { observer } from "mobx-react";

import { defined } from "@formant/core/common/defined";

import { organizationStore, routerStore, userStore } from "../../stores";
import { formatUserDisplayName } from "../../utils/formatUserDisplayName";
import { Avatar } from "../common/Avatar";
import { Button } from "../common/Button";
import styles from "./AccountLink.scss";

export interface IAccountLinkProps {
    onClose: () => void;
}

@observer
export class AccountLink extends Component<IAccountLinkProps> {
    public render() {
        const { onClose } = this.props;

        const user = userStore.authenticated();
        if (!user) {
            return false;
        }

        const organization = organizationStore.authenticated();
        if (!organization) {
            return false;
        }

        const { routeTo } = routerStore;

        return (
            <Button
                className={classnames(styles["account-link"], styles.button)}
                to={routeTo.profile()}
                onClicked={onClose}
            >
                <Avatar
                    userId={defined(user.id)}
                    size="medium"
                    light={true}
                    className={styles.avatar}
                />
                <div className={styles.details}>
                    <div data-testid="username" className={styles.name}>
                        {formatUserDisplayName(user)}
                    </div>
                    <div
                        data-testid="organization-name"
                        className={styles.organization}
                    >
                        {organization.name}
                    </div>
                </div>
            </Button>
        );
    }
}
